import type { ChatUi } from '@voll-intelligence/genui-contract';
import type { GenUiEntry } from '../../shared/ui/registry.js';
import { TripsDeck } from './ui/trips.js';

export { TripsDeck } from './ui/trips.js';

/** Entrada de catálogo do `trips` (slot chat) — display-only (drawer interno). */
export const tripsEntry: GenUiEntry<Extract<ChatUi, { kind: 'trips' }>> = {
  kind: 'trips',
  slot: 'chat',
  render: ({ ui }) => <TripsDeck trips={ui.trips} />,
};
